/* eslint-disable vue/max-attributes-per-line */
<template>
  <div>
    <b-card v-if="notableType == 'driver'">
      <b-button
        variant="primary"
        :disabled="loading"
        @click="fetchLegacyNotes"
      >
        <b-spinner
          v-if="loading"
          small
        />
        <span v-else>Get Legacy Notes</span>
      </b-button>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-table
          v-if="showLegacyNotes"
          :fields="legacyNotesColumns"
          :items="legacyNotesList"
          responsive
          hover
          class="mt-2 text-center"
          show-empty
          empty-text="No matching legacy notes found"
        />
      </b-overlay>
    </b-card>
    <note-form
      v-if="notableType == 'driver' ? $can('write', 'driver-notes') : $can('write', 'user-notes')"
      :notable-type="notableType"
      @addedNote="fetchNotes"
    />
    <b-card
      no-body
      class="mb-0"
    >
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingNotes"
      >

        <b-row class="mt-2 px-2">
          <b-col md="12">
            <v-select
              id="category"
              v-model="categoryFilter"
              :options="categories"
            />
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchNotes"
            >
              <feather-icon
                icon="RefreshCwIcon"
              />
            </b-button>
          </b-col>
          <b-col
            v-for=" note in notes"
            :key="note.id"
            md="6"
          >
            <edit-note
              :note="note"
              :notable-type="notableType"
              @editedNote="fetchNotes"
            />
          </b-col>
        </b-row>
        <p
          v-if="notes.length === 0"
          class="d-flex justify-content-center p-3"
        >No matching notes found </p>
        <!-- <b-button
          v-else
          variant="flat"
          :disabled="displayedNotes > notesList.length"
          @click="displayedNotes += 10"
        >
          See more
        </b-button> -->
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton, BOverlay, BRow, BCol, BSpinner, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import NoteForm from './NoteForm.vue'
import EditNote from './EditNote.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import notesStore from '@/views/driver-user-shared/notes/store'
import useNotesList from './hooks/useNotesList'

const notableTypes = ['driver', 'user']

export default {
  components: {
    BCard,
    BOverlay,
    BButton,
    vSelect,
    NoteForm,
    EditNote,
    BRow,
    BCol,
    BSpinner,
    BTable,
  },
  props: {
    notableType: {
      type: String,
      validator: val => notableTypes.includes(val),
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('notes', notesStore)
    return {
      ...useNotesList(props, ctx),
    }
  },
}
</script>
